<script>
import ReportFilter from '@/views/live/components/ReportFilter'
import { breadcrumbEventBus } from '@/main'
import UserService from '@/services/UserService'
import LocationSummaryCard from '@/views/live/components/LocationSummaryCard'

export default {
  components: {
    ReportFilter,
    LocationSummaryCard
  },
  data () {
    return {
      comparison: 'lastweek',
      locationsSummary: [],
      trends: {},
      locations: []
    }
  },
  created () {
    this.location_id = this.$route.params.location_id
  },
  mounted () {
    this.locations = UserService.getLocationsWithPermission('view daily')
    breadcrumbEventBus.$emit('breadcrumbChanged', [])
  },
  methods: {
    onGetComparison: function (comparison) {
      this.comparison = comparison
    }
  }
}
</script>

<template>
     <div class="container-fluid">
    <report-filter
      :comparison="comparison"
      @updateComparison="onGetComparison"
    ></report-filter>
        <LocationSummaryCard
          v-for="(location, index) in locations"
          :key="index"
          :comparison="comparison"
          :location="location"
        ></LocationSummaryCard>
    </div>
</template>

<style scoped>
.list-group-item {
  width: 100%;
}
</style>
